export default __webpack_public_path__ + "static/media/026-intersection-1.2a9df5e9.png";